export const categories = [
  { id: 1, name: 'Comedores', slug: 'comedores', description: 'Mesas de parota, live edge y contemporáneas para 4 a 12 personas. Piezas únicas a la medida.', image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/c2b3bf20-961f-48d8-e2e4-dd1dd2d0ec00/public', icon: '🍽️' },
  { id: 2, name: 'Sillas & Bancas', slug: 'sillas-bancas', description: 'Sillas de comedor, bancas y taburetes artesanales en madera sólida y tejido premium.', image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/08bbce40-0101-4a0b-567b-39a2073b8b00/public', icon: '🪑' },
  { id: 3, name: 'Sala', slug: 'sala', description: 'Sofás, sillones, mesas de centro y credenzas para espacios de living con carácter.', image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/e755a61f-077d-416e-677b-78223d736000/public', icon: '🛋️' },
  { id: 4, name: 'Recámaras', slug: 'recamaras', description: 'Camas plataforma, literas y burós en parota y rosa morada. Conjuntos completos a la medida.', image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7875e675-e29f-47fe-69f2-cf263bf69c00/public', icon: '🛏️' },
  { id: 5, name: 'Exterior', slug: 'exterior', description: 'Camastros, conjuntos de terraza y mesas para exterior en teca certificada y parota.', image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f5741ec8-762a-4cb7-7939-61490a958300/public', icon: '🌿' },
  { id: 6, name: 'Consolas & TV', slug: 'consolas-tv', description: 'Consolas, bufeteras y muebles para TV con diseño contemporáneo o clásico en madera sólida.', image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a67b1d12-a852-4ee7-071f-9529145ef700/public', icon: '📺' },
  { id: 7, name: 'Oficina', slug: 'oficina', description: 'Escritorios ejecutivos, en L y mesas de conferencia en maderas premium mexicanas.', image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/c9b31e35-f7bf-43d8-5009-76cb865c7500/public', icon: '💼' },
  { id: 8, name: 'Equipales', slug: 'equipales', description: 'Muebles estilo hacienda y bistró en madera y cuero natural. Ideales para restaurantes y casa.', image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/6d89ebe4-0a87-4c95-5c56-b171b7926c00/publicContain', icon: '🏺' },
  { id: 9, name: 'Accesorios', slug: 'accesorios', description: 'Lámparas, barras modulares, percheros, alacenas y accesorios decorativos artesanales.', image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/fdd0a592-0334-4c65-f02b-120425f42a00/public', icon: '✨' },
];

export const collectionItems = [
  // ── COMEDORES ──────────────────────────────────────────────────────────────
  {
    id: 1,
    name: 'Conjunto Comedor Cuadrado 8 Personas',
    category: 'Comedores',
    tag: 'Mid-Century',
    material: 'Parota',
    description: 'Mesa de parota maciza cuadrada con 8 sillas mid-century. Asiento tapizado negro, respaldo envolvente. Conjunto completo o por piezas.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/c2b3bf20-961f-48d8-e2e4-dd1dd2d0ec00/public',
    dimensions: 'Mesa 160×160×75 cm',
    price: null,
  },
  {
    id: 2,
    name: 'Mesa Comedor Parota 8 Personas',
    category: 'Comedores',
    tag: 'Natural',
    material: 'Parota',
    description: 'Mesa de parota maciza rectangular para 8 personas. Acabado natural con veta marcada y canto biselado suave.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/469b9613-138b-495d-3a99-8c087adf2300/public',
    dimensions: '200×100×75 cm',
    price: null,
  },
  {
    id: 3,
    name: 'Comedor Live Edge Parota 6 Plazas',
    category: 'Comedores',
    tag: 'Live Edge',
    material: 'Parota',
    description: 'Mesa live edge con borde orgánico natural de parota. Patas en X de metal negro mate. Acabado mate sellado. Cada pieza es única.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/31da9c3d-34b7-4ec6-d370-71125f17e300/publicContain',
    dimensions: '180-200×90×75 cm',
    price: null,
  },
  {
    id: 4,
    name: 'Mesa Comedor Contemporánea Madera Sólida',
    category: 'Comedores',
    tag: 'Contemporáneo',
    material: 'Madera Sólida',
    description: 'Mesa contemporánea con cubierta de veta continua laminada y base en marcos U invertidos. Canto biselado limpio.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/ef770dd9-a48e-4660-6c3d-da44c17e3800/public',
    dimensions: '200×90×75 cm',
    price: null,
  },
  {
    id: 5,
    name: 'Mesa Comedor Efecto Río con Vidrio',
    category: 'Comedores',
    tag: 'River Table',
    material: 'Madera Sólida',
    description: 'Mesa river table con canal central de vidrio templado que simula un río. Canto natural vivo. Base con travesaño central. Pieza exclusiva.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/70d85220-10f5-42c0-bf9d-15199be56700/publicContain',
    dimensions: 'Bajo cotización',
    price: null,
  },
  {
    id: 6,
    name: 'Mesa Tronco Raíz',
    category: 'Comedores',
    tag: 'Pieza Única',
    material: 'Madera Sólida',
    description: 'Rebanada maciza de tronco con canto vivo natural y veta concéntrica. Rústico-elegante. Pieza 100% única, irrepetible.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/af6a834b-2610-491a-687c-4fb67fa96100/publicContain',
    dimensions: 'Variable — cada pieza es única',
    price: null,
  },
  {
    id: 7,
    name: 'Mesa Redonda Parota Base X Metálica',
    category: 'Comedores',
    tag: 'Industrial',
    material: 'Parota',
    description: 'Mesa redonda de parota maciza con canto suave y base en X de metal negro mate. Ideal para espacios pequeños o cocinas abiertas.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/6ad45b14-d2d0-4738-0037-a5b2bcb71d00/publicContain',
    dimensions: '120-150 cm diámetro × 75 cm',
    price: null,
  },
  {
    id: 8,
    name: 'Comedor Redondo Parota + Sillas Tejidas',
    category: 'Comedores',
    tag: 'Artesanal',
    material: 'Parota',
    description: 'Conjunto completo: mesa redonda de parota con base cónica y sillas con respaldo tejido en ratán sintético y cojín desenfundable.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/57a3d564-5eae-4d46-bbdf-ac701763f900/public',
    dimensions: 'Mesa 130 cm diámetro',
    price: null,
  },
  {
    id: 9,
    name: 'Mesa de Comedor Rectangular Contemporánea',
    category: 'Comedores',
    tag: 'Soft Edge',
    material: 'Madera Sólida',
    description: 'Mesa rectangular con esquinas redondeadas, cantos suaves y soportes tipo panel sólido con ranura vertical decorativa. Líneas orgánicas.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/186c3738-213f-4c1b-1020-5e046a6f4700/public',
    dimensions: '200×95×75 cm',
    price: null,
  },
  {
    id: 10,
    name: 'Comedor Rectangular 8 Personas',
    category: 'Comedores',
    tag: 'Contemporáneo',
    material: 'Madera Sólida',
    description: 'Comedor completo para 8: mesa con cubierta amplia y patas rectangulares en esquinas, más 8 sillas con brazos integrados y tapizado claro.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/0800d90b-bc45-42a6-43c1-e7f886ba7100/public',
    dimensions: 'Mesa 220×100×75 cm',
    price: null,
  },
  {
    id: 11,
    name: 'Comedor Cubierta Orgánica 8 Personas',
    category: 'Comedores',
    tag: 'Live Edge',
    material: 'Madera Sólida',
    description: 'Mesa con canto natural tipo live edge, base en X y 8 sillas con respaldo envolvente, brazos integrados y tapizado premium.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/2fa55f9f-dee5-4c1f-18f4-cadc57e26600/publicContain',
    dimensions: 'Mesa 220×100×75 cm',
    price: null,
  },

  // ── SILLAS & BANCAS ────────────────────────────────────────────────────────
  {
    id: 12,
    name: 'Banco para Barra con Respaldo Envolvente',
    category: 'Sillas & Bancas',
    tag: 'Parota',
    material: 'Parota',
    description: 'Banco de parota para barras y desayunadores. Respaldo envolvente de madera sólida y asiento tapizado en piel. Altura regulable bajo cotización.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/28d71341-3be2-4184-fcc2-e090cf76ef00/public',
    dimensions: '42×45×65 cm (asiento)',
    price: null,
  },
  {
    id: 13,
    name: 'Sillas Comedor Respaldo Tejido',
    category: 'Sillas & Bancas',
    tag: 'Artesanal',
    material: 'Parota',
    description: 'Silla de comedor con estructura de parota maciza y respaldo curvo tejido a mano en fibra natural tipo ratán. Cojín en tela marfil desenfundable.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/08bbce40-0101-4a0b-567b-39a2073b8b00/public',
    dimensions: '48×52×90 cm',
    price: null,
  },
  {
    id: 14,
    name: 'Silla Cronos',
    category: 'Sillas & Bancas',
    tag: 'Mid-Century',
    material: 'Madera Sólida',
    description: 'Silla mid-century con respaldo y brazos curvados en una sola pieza de madera, patas torneadas cónicas y tapizado premium de alto desempeño.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7ec9abe7-c6ad-45a1-95a4-4e5f45c36400/public',
    dimensions: '50×55×88 cm',
    price: null,
  },
  {
    id: 15,
    name: 'Silla Cancún',
    category: 'Sillas & Bancas',
    tag: 'Geométrico',
    material: 'Madera Sólida',
    description: 'Silla con diseño geométrico de líneas oblicuas en madera sólida. Versátil como silla de acento o comedor. Disponible en múltiples maderas y acabados.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/adbf5000-8202-4aa8-2720-b1eb03347e00/public',
    dimensions: '46×50×86 cm',
    price: null,
  },
  {
    id: 16,
    name: 'Banco Tejido de Ratán',
    category: 'Sillas & Bancas',
    tag: 'Artesanal',
    material: 'Tejido',
    description: 'Banco alto con estructura de madera sólida y asiento-respaldo tejido en ratán con patrón cruzado. Reposapiés integrado. Acabado natural.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/d4532b22-3e0b-44ee-ae38-fca3cef39e00/public',
    dimensions: '40×40×75 cm',
    price: null,
  },
  {
    id: 17,
    name: 'Silla Malta',
    category: 'Sillas & Bancas',
    tag: 'Clásico',
    material: 'Madera Sólida',
    description: 'Silla de comedor con respaldo de listones cruzados y asiento tapizado en tela de alto desempeño. Confort y durabilidad para uso diario.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7f11f1d6-0d40-44fb-d952-835b8f00fb00/public',
    dimensions: '47×52×90 cm',
    price: null,
  },
  {
    id: 18,
    name: 'Silla Redonda Tejida en Nailon',
    category: 'Sillas & Bancas',
    tag: 'Náutico',
    material: 'Tejido',
    description: 'Diseño envolvente con aro circular de madera y asiento-respaldo trenzado en cordón de nailon náutico. Moderna y duradera.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/b6cc2cde-dc3d-4d72-2287-24868c4d6600/publicContain',
    dimensions: '70 cm diámetro × 80 cm alto',
    price: null,
  },
  {
    id: 19,
    name: 'Silla Curva Tejida Cordón Náutico',
    category: 'Sillas & Bancas',
    tag: 'Artesanal',
    material: 'Tejido',
    description: 'Silla de parota con respaldo y brazos en pieza curva única y asiento tejido a mano en cordón náutico. Válida para comedor y terraza.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a5529f0d-0bf6-454a-4de3-bf0dd9149400/publicContain',
    dimensions: '55×58×84 cm',
    price: null,
  },
  {
    id: 20,
    name: 'Silla Beta – Respaldo X',
    category: 'Sillas & Bancas',
    tag: 'Farmhouse',
    material: 'Madera Sólida',
    description: 'Silla farmhouse con icónico respaldo en cruz X y asiento tapizado acolchonado. Robustez y carácter rústico para comedores con personalidad.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/94538774-064f-45a1-bcda-641297091900/public',
    dimensions: '46×50×88 cm',
    price: null,
  },
  {
    id: 21,
    name: 'Banco Alto con Respaldo Bajo',
    category: 'Sillas & Bancas',
    tag: 'Parota',
    material: 'Parota',
    description: 'Banco de parota para barra con respaldo bajo envolvente tipo sling y asiento tapizado en tela gris-azulada. Apoyapiés integrado.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/ac8fd5ff-4055-43b5-ef4a-12b95f325500/public',
    dimensions: '42×46×65 cm (asiento)',
    price: null,
  },
  {
    id: 22,
    name: 'Bancos Altos Parota Patas en A',
    category: 'Sillas & Bancas',
    tag: 'Parota',
    material: 'Parota',
    description: 'Banco alto de parota maciza con patas en A y respaldo bajo tipo sling. Asiento tapizado de alta densidad en tela clara. Elegante y resistente.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/c5bff805-f2ef-4f1b-6563-01dd96dbfb00/public',
    dimensions: '42×44×65 cm (asiento)',
    price: null,
  },
  {
    id: 23,
    name: 'Silla Miami – Parota y Tapiz',
    category: 'Sillas & Bancas',
    tag: 'Contemporáneo',
    material: 'Parota',
    description: 'Silla de parota sólida con respaldo bajo curvo y brazos integrados tipo media luna. Asiento tapizado acolchado de alta densidad.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/c73e002a-4b91-48f1-5f77-f93ebf235900/public',
    dimensions: '55×58×78 cm',
    price: null,
  },
  {
    id: 24,
    name: 'Silla Tradicional Madera Maciza',
    category: 'Sillas & Bancas',
    tag: 'Tradicional',
    material: 'Madera Sólida',
    description: 'Silla tradicional con diseño envolvente y líneas limpias. Respaldo y brazos en pieza curva de madera maciza. Asiento cóncavo tallado. Acabado natural.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/39fcf258-1cab-4bab-0a08-39f0e7665200/publicContain',
    dimensions: '52×56×88 cm',
    price: null,
  },
  {
    id: 25,
    name: 'Sillón Tapizado Brazo Geométrico',
    category: 'Sillas & Bancas',
    tag: 'Mid-Century',
    material: 'Parota',
    description: 'Sillón de parota con brazos y patas angulares geométricas. Respaldo recto alto y asiento amplio tapizado en tela gris. Estilo mid-century premium.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a223eb2f-5e68-49b2-aa04-a97a66169900/public',
    dimensions: '65×70×90 cm',
    price: null,
  },
  {
    id: 26,
    name: 'Silla Encino Color Gris',
    category: 'Sillas & Bancas',
    tag: 'Escandinavo',
    material: 'Encino',
    description: 'Silla de encino color gris con patas delgadas y estilizadas, tapizado beige y respaldo curvo. Ideal para comedor o sala. Estilo escandinavo.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/5a14ab0e-712f-4b72-6df8-480e43eb6a00/publicContain',
    dimensions: '50×52×86 cm',
    price: null,
  },
  {
    id: 27,
    name: 'Silla Riviera – Teca y Cuerda',
    category: 'Sillas & Bancas',
    tag: 'Náutico',
    material: 'Teca',
    description: 'Silla de teca maciza con asiento y respaldo tejido en cuerda náutica de olefina con protección UV. Uniones espiga tradicional. Opción cojín.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/92c4c5eb-d6f6-47ed-9ec1-cba7643a7200/publicContain',
    dimensions: '52×55×88 cm',
    price: null,
  },
  {
    id: 28,
    name: 'Banco Riviera – Tejido Artesanal',
    category: 'Sillas & Bancas',
    tag: 'Artesanal',
    material: 'Parota',
    description: 'Banco alto con respaldo bajo envolvente y asiento tejido a mano en cuerda trenzada. Perfecto para barras y desayunadores. Alta resistencia.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/754d30af-934d-4737-8b99-6b26cbf5fa00/publicContain',
    dimensions: '42×44×65 cm (asiento)',
    price: null,
  },
  {
    id: 29,
    name: 'Silla Verona – Cuero Trenzado',
    category: 'Sillas & Bancas',
    tag: 'Artesanal',
    material: 'Cuero',
    description: 'Silla de comedor con respaldo tejido a mano en tiras de cuero y asiento tapizado acolchado. Estructura de madera maciza. Pieza artesanal premium.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/209473d5-a65c-4fbe-df97-8c1209b7ee00/publicContain',
    dimensions: '48×52×90 cm',
    price: null,
  },
  {
    id: 30,
    name: 'Silla Wishbone – Escandinava',
    category: 'Sillas & Bancas',
    tag: 'Nórdico',
    material: 'Madera Sólida',
    description: 'Silla tipo Wishbone (Y Chair) con respaldo en aro curvo continuo y soporte central en Y. Asiento tejido en cuerda con patrón diagonal. Ícono escandinavo.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7ab084c1-97d6-48ff-1e75-feb5d5d40b00/public',
    dimensions: '50×52×76 cm',
    price: null,
  },
  {
    id: 31,
    name: 'Banco Alto Tapizado – Barra/Isla',
    category: 'Sillas & Bancas',
    tag: 'Nórdico',
    material: 'Madera Sólida',
    description: 'Banco alto tapizado sin brazos con respaldo bajo tipo media luna y cojín grueso. Travesaños para apoyar los pies. Ideal para islas de cocina.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/66daa41b-2744-40b4-4d2c-f59144a28700/publicContain',
    dimensions: '42×44×65 cm (asiento)',
    price: null,
  },
  {
    id: 32,
    name: 'Silla Lounge – Cuerda y Macramé',
    category: 'Sillas & Bancas',
    tag: 'Contemporáneo',
    material: 'Tejido',
    description: 'Silla individual tipo lounge con patas marco en U, laterales con tejido de cuerda beige tipo macramé y cojines sueltos en tela arena. Relajante y elegante.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a7abf5ce-3988-49e7-221a-3ba734513000/public',
    dimensions: '75×80×78 cm',
    price: null,
  },
  {
    id: 33,
    name: 'Silla Nórdica – Ratán y Cordón',
    category: 'Sillas & Bancas',
    tag: 'Escandinavo',
    material: 'Tejido',
    description: 'Silla escandinava con estructura de madera tono natural, patas cilíndricas con refuerzo en H y asiento tejido en cordón ratán sintético beige.',
    image: 'https://www.exportmuebles.com/assets/uploads/49f6111e-11c1-4a82-9e67-06d600d08619/4aeb2c60-0caf-43bc-a48c-910ed757134f.jpg?w=480',
    dimensions: '48×50×82 cm',
    price: null,
  },
  {
    id: 34,
    name: 'Banco Alto con Brazos – Barra/Isla',
    category: 'Sillas & Bancas',
    tag: 'Contemporáneo',
    material: 'Madera Sólida',
    description: 'Banco mid-century de altura de counter con brazos integrados, respaldo tapizado en crema y estructura de madera. Cómodo y elegante.',
    image: 'https://www.exportmuebles.com/assets/uploads/49f6111e-11c1-4a82-9e67-06d600d08619/845a0f59-69ed-4af2-bcdc-3d8e29117965.jpg?w=480',
    dimensions: '42×48×65 cm (asiento)',
    price: null,
  },
  {
    id: 35,
    name: 'Silla Rosa Morada – Tapizada',
    category: 'Sillas & Bancas',
    tag: 'Elegante',
    material: 'Rosa Morada',
    description: 'Silla de rosa morada con respaldo envolvente media luna, asiento tapizado en tela arena-beige y patas cilíndricas. Sofisticada y cálida.',
    image: 'https://www.exportmuebles.com/assets/uploads/49f6111e-11c1-4a82-9e67-06d600d08619/2f67d935-4cbd-42de-a1b6-30975adc81f0.jpg?w=480',
    dimensions: '52×56×82 cm',
    price: null,
  },

  // ── SALA ───────────────────────────────────────────────────────────────────
  {
    id: 36,
    name: 'Mesa Auxiliar Redonda Parota',
    category: 'Sala',
    tag: 'Industrial',
    material: 'Parota',
    description: 'Mesa auxiliar redonda de parota maciza con veta marcada sobre base de acero negro mate. Diseño esbelto y moderno.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/ee1f7ae5-7447-44b7-8c18-1b77d1862900/public',
    dimensions: '50 cm diámetro × 55 cm',
    price: null,
  },
  {
    id: 37,
    name: 'Sillón Yakuza',
    category: 'Sala',
    tag: 'Artesanal',
    material: 'Parota',
    description: 'Sillón de parota con brazos facetados tallados a mano y tapizado en tela tipo lino gris. Alta densidad. Pieza de carácter fuerte y presencia única.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/9969d32a-c0cb-4cf2-459b-3cf571790300/publicContain',
    dimensions: '80×85×90 cm',
    price: null,
  },
  {
    id: 38,
    name: 'Espejos Decorativos Marco de Madera',
    category: 'Sala',
    tag: 'Decorativo',
    material: 'Madera Sólida',
    description: 'Par de espejos decorativos con marco de madera maciza, diseño ovaloide alargado y perfil delgado continuo. Veta natural visible.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/933222f7-962d-4ddc-ace9-a953b03a3d00/public',
    dimensions: '40×120 cm (cada espejo)',
    price: null,
  },
  {
    id: 39,
    name: 'Sillón Estilo Camastro',
    category: 'Sala',
    tag: 'Relajante',
    material: 'Parota',
    description: 'Sillón con estructura de parota, patas y respaldo inclinados tipo camastro. Cojines desmontables en tela tipo lino. Postura naturalmente relajada.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/6116912e-f7f9-46a9-062b-4d2b0ca62600/public',
    dimensions: '85×90×95 cm',
    price: null,
  },
  {
    id: 40,
    name: 'Sillón Butterfly Piel con Pelo',
    category: 'Sala',
    tag: 'Pieza Única',
    material: 'Cuero',
    description: 'Sillón Butterfly en piel con pelo cosida artesanalmente. Base tubular metálica cruzada en acabado cobre. Pieza única de alto impacto visual.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/b5502c6a-deb9-46d1-aeeb-8f6c58a38600/public',
    dimensions: '90×85×75 cm',
    price: null,
  },
  {
    id: 41,
    name: 'Sillón Lounge Tejido en Piel',
    category: 'Sala',
    tag: 'Artesanal',
    material: 'Cuero',
    description: 'Sillón lounge con entramado de tiras de piel en patrón cruzado y estructura de parota de líneas curvas. Acabado mate. Artesanía de alto nivel.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/327642a4-c7e4-4b55-1596-550a3d566100/public',
    dimensions: '80×85×88 cm',
    price: null,
  },
  {
    id: 42,
    name: 'Mesa de Centro Orgánica',
    category: 'Sala',
    tag: 'Orgánico',
    material: 'Parota',
    description: 'Mesa de centro con cubierta oval orgánica de parota y tonos miel-chocolate sobre pedestales acanalados gemelos. Canto redondeado suave.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/2e8f7656-e91d-4274-25a6-fdd1bf2e8b00/public',
    dimensions: '120×65×42 cm',
    price: null,
  },
  {
    id: 43,
    name: 'Mesa de Centro Rectangular – Veta Marcada',
    category: 'Sala',
    tag: 'Contemporáneo',
    material: 'Madera Sólida',
    description: 'Mesa de centro con cubierta de madera maciza de veta marcada, bordes biselados y base de 4 patas rectas con travesaños en X.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/5c9f7df8-8007-4ab5-b5be-403f02002000/public',
    dimensions: '120×60×42 cm',
    price: null,
  },
  {
    id: 44,
    name: 'Cajonera Encino Color Gris',
    category: 'Sala',
    tag: 'Escandinavo',
    material: 'Encino',
    description: 'Cajonera de encino color gris claro con vetas naturales visibles, frente liso de 4 puertas sin jaladeras, esquinas redondeadas y base corrida.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/4306c4bd-a86c-4619-5c03-086a4fbe5700/publicContain',
    dimensions: '120×40×80 cm',
    price: null,
  },
  {
    id: 45,
    name: 'Cajonera Soft Blocks',
    category: 'Sala',
    tag: 'Orgánico',
    material: 'Encino',
    description: 'Cajonera con 8 cajones y nicho abierto de líneas orgánicas y esquinas redondeadas en encino claro. Cierre suave. Acabado mate natural.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/45a97b4b-ac94-4e8b-2a68-c7f6a2982700/public',
    dimensions: '100×42×90 cm',
    price: null,
  },
  {
    id: 46,
    name: 'Sofá Seccional Parota Milano',
    category: 'Sala',
    tag: 'Mid-Century',
    material: 'Parota',
    description: 'Sofá seccional en L con estructura de parota maciza y chaise derecha. Estilo mid-century moderno con líneas rectas y perfil bajo elegante.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/e755a61f-077d-416e-677b-78223d736000/public',
    dimensions: '280×160×85 cm',
    price: null,
  },
  {
    id: 47,
    name: 'Sofá Chester Parota Navy',
    category: 'Sala',
    tag: 'Clásico',
    material: 'Parota',
    description: 'Sofá estilo Chesterfield con capitoné profundo en terciopelo azul marino y estructura de parota maciza. Patas cónicas. Pieza de colección.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/0e57af0c-ae7b-4162-b129-3ff0ab54fe00/public',
    dimensions: '220×90×85 cm (3 plazas)',
    price: null,
  },
  {
    id: 48,
    name: 'Mesa de Centro Duna',
    category: 'Sala',
    tag: 'Orgánico',
    material: 'Madera Sólida',
    description: 'Mesa de centro con silueta orgánica ovalada y base doble tipo aletas de madera sólida. Cantos redondeados. Inspiración natural en cada línea.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/58d8deac-5c73-43e8-3446-4f9c52d39e00/publicContain',
    dimensions: '110×60×40 cm',
    price: null,
  },
  {
    id: 49,
    name: 'Sillón Tejido – Verde Olivo',
    category: 'Sala',
    tag: 'Bohemio',
    material: 'Tejido',
    description: 'Sillón individual con marco de madera, laterales y respaldo con cordón tejido tipo macramé. Cojines en tela verde olivo. Boho elegante.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/85b6d099-cbd9-4fdf-e90a-745bad84ac00/publicContain',
    dimensions: '75×80×85 cm',
    price: null,
  },
  {
    id: 50,
    name: 'Credenza / Bufetera – 4 Puertas',
    category: 'Sala',
    tag: 'Contemporáneo',
    material: 'Madera Sólida',
    description: 'Credenza baja con 4 puertas de veta vertical continua y acabado soft edge. Base zócalo corrido con efecto flotante. Líneas contemporáneas.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/52a2602f-228f-4b29-1879-7861364e2000/public',
    dimensions: '180×45×60 cm',
    price: null,
  },

  // ── EXTERIOR ───────────────────────────────────────────────────────────────
  {
    id: 51,
    name: 'Camastro de Teca para Exterior',
    category: 'Exterior',
    tag: 'Teca',
    material: 'Teca',
    description: 'Camastro de teca certificada con listones ventilados y respaldo reclinable en múltiples posiciones. Resistente a la intemperie. Sin mantenimiento.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7c5c8fdd-34b0-4477-3242-556071c10a00/publicContain',
    dimensions: '70×200×35 cm',
    price: null,
  },
  {
    id: 52,
    name: 'Conjunto Terraza Cuerda Náutica',
    category: 'Exterior',
    tag: 'Náutico',
    material: 'Parota',
    description: 'Conjunto para terraza de parota con cuerda náutica resistente a UV. Incluye sillones, mesa central y cojines outdoor. Estilo costero premium.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f5741ec8-762a-4cb7-7939-61490a958300/public',
    dimensions: 'Variable según configuración',
    price: null,
  },
  {
    id: 53,
    name: 'Mesa Terraza en Teca con Base Acero',
    category: 'Exterior',
    tag: 'Teca',
    material: 'Teca',
    description: 'Mesa de terraza en teca certificada con base de acero inoxidable en X. Para intemperie, resistente a lluvia y sol. Duradera por décadas.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/86f2bc25-726a-4a26-c863-36777bd71b00/public',
    dimensions: '120×80×75 cm',
    price: null,
  },
  {
    id: 54,
    name: 'Mecedora en Teca',
    category: 'Exterior',
    tag: 'Teca',
    material: 'Teca',
    description: 'Mecedora artesanal en teca maciza con balance suave y veta cálida natural. Ideal para porches, terrazas o jardines. Rústico-elegante.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/3cec3509-785e-4210-f828-4cdcbb292a00/publicContain',
    dimensions: '58×80×100 cm',
    price: null,
  },
  {
    id: 55,
    name: 'Set Sala Exterior – Resort / Boho',
    category: 'Exterior',
    tag: 'Resort',
    material: 'Tejido',
    description: 'Set para sala exterior 3-1-1 piezas en ratán sintético con cojines outdoor en tonos naturales. Perfecto para terrazas, jardines y albercas.',
    image: 'https://www.exportmuebles.com/assets/uploads/49f6111e-11c1-4a82-9e67-06d600d08619/ac42312e-f610-490f-a931-463442dae6d1.jpg?w=480',
    dimensions: 'Sofá: 180×80×85 cm',
    price: null,
  },

  // ── CONSOLAS & TV ──────────────────────────────────────────────────────────
  {
    id: 56,
    name: 'Consola Moderna Lacada Negro Mate',
    category: 'Consolas & TV',
    tag: 'Moderno',
    material: 'Parota',
    description: 'Consola de parota con cuerpo lacado negro mate, dos puertas laterales y 3 cajones centrales con jaladeras ocultas. Contraste cálido-oscuro.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a67b1d12-a852-4ee7-071f-9529145ef700/public',
    dimensions: '160×40×85 cm',
    price: null,
  },
  {
    id: 57,
    name: 'Consola Rosa Morada Estilo Caballete',
    category: 'Consolas & TV',
    tag: 'Caballete',
    material: 'Rosa Morada',
    description: 'Consola en rosa morada con estructura tipo caballetes en X. Tonos miel-ámbar únicos con vetas doradas. Para recibidor o sala.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/eab1f32e-4638-4b28-2947-3de95e823100/publicContain',
    dimensions: '140×38×80 cm',
    price: null,
  },
  {
    id: 58,
    name: 'Mesa Consola Contemporánea Parota',
    category: 'Consolas & TV',
    tag: 'Contemporáneo',
    material: 'Parota',
    description: 'Consola de líneas robustas con patas inclinadas tipo caballete de parota y tres cajones centrales con correderas suaves. Acabado satinado.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/40b8ef3a-5f9f-42ea-ec23-cf069dd65c00/public',
    dimensions: '140×38×80 cm',
    price: null,
  },
  {
    id: 59,
    name: 'Mueble de TV Moderno en Nogal',
    category: 'Consolas & TV',
    tag: 'Moderno',
    material: 'Madera Sólida',
    description: 'Mueble de TV moderno en tono nogal con base de estructura metálica negra. 2 cajones con correderas soft-close y nichos abiertos para componentes.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/596d34d8-3532-4eaa-e264-ef4dc0134a00/publicContain',
    dimensions: '160×45×55 cm',
    price: null,
  },
  {
    id: 60,
    name: 'Consola Arco',
    category: 'Consolas & TV',
    tag: 'Orgánico',
    material: 'Madera Sólida',
    description: 'Consola de líneas suaves con esquinas redondeadas 360°. Dos módulos de cajones, gabinete central y tres nichos abiertos. Frente completamente limpio.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/6992f204-45f0-43c0-4d4d-53e5112c9700/publicContain',
    dimensions: '180×42×80 cm',
    price: null,
  },
  {
    id: 61,
    name: 'Bufetera Horizonte',
    category: 'Consolas & TV',
    tag: 'Contemporáneo',
    material: 'Madera Sólida',
    description: 'Bufetera con veta corrida en tres módulos: cajones a los lados y puertas al centro. Base con efecto flotante. Líneas horizontales premium.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/64b8bf1b-328c-4103-b442-612c2c5b3600/publicContain',
    dimensions: '200×45×65 cm',
    price: null,
  },
  {
    id: 62,
    name: 'Mueble de TV Flotante 4 Puertas',
    category: 'Consolas & TV',
    tag: 'Flotante',
    material: 'Madera Sólida',
    description: 'Mueble de TV flotante con montaje a muro, 4 compartimentos con puertas abatibles y jaladeras negras. Minimalista y funcional.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/ecf7b4d8-a00c-4e00-3134-a5335ab9e500/public',
    dimensions: '160×30×45 cm',
    price: null,
  },
  {
    id: 63,
    name: 'Consola Marco U – Recibidor / Tocador',
    category: 'Consolas & TV',
    tag: 'Japandi',
    material: 'Madera Sólida',
    description: 'Consola japandi con tapa delgada, 2 cajones push-to-open y patas en U con travesaño. Perfecta para recibidor o como tocador.',
    image: 'https://www.exportmuebles.com/assets/uploads/49f6111e-11c1-4a82-9e67-06d600d08619/7efaf108-cd48-436d-8744-640184da04d4.jpg?w=480',
    dimensions: '120×40×78 cm',
    price: null,
  },

  // ── RECÁMARAS ──────────────────────────────────────────────────────────────
  {
    id: 64,
    name: 'Recámara Moderna en Parota',
    category: 'Recámaras',
    tag: 'Moderno',
    material: 'Parota',
    description: 'Conjunto completo: cama plataforma, cabecera panel horizontal, banca slatted al pie y buró con cajón. Parota maciza, acabado satinado.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7875e675-e29f-47fe-69f2-cf263bf69c00/public',
    dimensions: 'King / Queen / Individual',
    price: null,
  },
  {
    id: 65,
    name: 'Cama Plataforma con Cabecera Entramada',
    category: 'Recámaras',
    tag: 'Artesanal',
    material: 'Parota',
    description: 'Cama plataforma de parota con cabecera de cuadros entramados. Estructura sólida con zócalo retranqueado. Diseño artesanal moderno.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7d25e297-1b73-490b-9eac-a6b5cd23e500/publicContain',
    dimensions: 'King / Queen',
    price: null,
  },
  {
    id: 66,
    name: 'Litera en Parota',
    category: 'Recámaras',
    tag: 'Funcional',
    material: 'Parota',
    description: 'Litera de parota de líneas redondeadas con almacenamiento integrado. Escalera lateral con peldaños amplios. Segura y duradera.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/87621299-f901-447e-e8f2-2b72c751cb00/publicContain',
    dimensions: 'Individual / Matrimonial',
    price: null,
  },
  {
    id: 67,
    name: 'Cama Plataforma en Rosa Morada',
    category: 'Recámaras',
    tag: 'Elegante',
    material: 'Rosa Morada',
    description: 'Cama plataforma en rosa morada con cabecera tapizada premium. Tonos naturales rojizos únicos. Madera de alta dureza y elegancia excepcional.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/03279303-3fd8-459f-a596-59c7c5b32c00/public',
    dimensions: 'King / Queen',
    price: null,
  },
  {
    id: 68,
    name: 'Cama Plataforma con Burós Integrados',
    category: 'Recámaras',
    tag: 'Minimalista',
    material: 'Rosa Morada',
    description: 'Cama de rosa morada con base de zócalo retranqueado efecto flotante. Cabecera corrida y burós volados integrados a los lados. Diseño minimalista.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/975fc97b-0ed1-4e65-7356-bd5e4e989f00/publicContain',
    dimensions: 'King / Queen',
    price: null,
  },
  {
    id: 69,
    name: 'Cama Parota – Cabecera Curva Modular',
    category: 'Recámaras',
    tag: 'Live Edge',
    material: 'Parota',
    description: 'Cama plataforma de parota con cantos orgánicos y cabecera en 3 secciones modulares. Burós flotantes con cajón a los lados. Exclusiva.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/c7ae704a-59a2-4908-5233-37c6c7f33500/public',
    dimensions: 'King / Queen',
    price: null,
  },
  {
    id: 70,
    name: 'Recámara Rústica Madera Maciza',
    category: 'Recámaras',
    tag: 'Rústico',
    material: 'Madera Sólida',
    description: 'Conjunto rústico: cabecera de tablones verticales, banco pie de cama tapizado en lino capitoné y buró lateral. Acabado envejecido artesanal.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/96d55bf5-2c1a-48c1-4171-52413e6ab300/public',
    dimensions: 'King / Queen / Matrimonial',
    price: null,
  },
  {
    id: 71,
    name: 'Buró Cube en Parota',
    category: 'Recámaras',
    tag: 'Minimalista',
    material: 'Parota',
    description: 'Buró de parota con diseño monolítico, esquinas redondeadas y 2 cajones con jaladeras integradas tipo uñero. Simple y elegante.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7a9e71dc-e6d5-4a67-101b-6ffab5d1ea00/public',
    dimensions: '50×42×55 cm',
    price: null,
  },
  {
    id: 72,
    name: 'Buró Cube Leg – Acabado Oscuro',
    category: 'Recámaras',
    tag: 'Mid-Century',
    material: 'Parota',
    description: 'Buró de parota en acabado oscuro con patas cónicas mid-century y base elevada. 2 cajones amplios con uñero integrado.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7aed401e-68fd-44c6-f499-c94f1ea17300/publicContain',
    dimensions: '52×42×58 cm',
    price: null,
  },
  {
    id: 73,
    name: 'Buró Minimalista Parota 2 Cajones',
    category: 'Recámaras',
    tag: 'Minimalista',
    material: 'Parota',
    description: 'Buró con jaladera gola integrada, base flotante y veta continua de parota. 2 cajones de cierre suave. Diseño minimalista sin distracción.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/0d9d7225-0c60-4d91-e733-c4f61d107d00/public',
    dimensions: '50×40×52 cm',
    price: null,
  },
  {
    id: 74,
    name: 'Buró Parota Frente Ranurado',
    category: 'Recámaras',
    tag: 'Artesanal',
    material: 'Parota',
    description: 'Buró de parota con frente ranurado tipo louver que disimula los cajones ocultos. Push-to-open sin jaladera. Diseño limpio y original.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/9ff0d652-4b59-41cd-2bac-a058cf9fe900/publicContain',
    dimensions: '50×42×55 cm',
    price: null,
  },
  {
    id: 75,
    name: 'Cama Litera / Loft – Rústico Minimalista',
    category: 'Recámaras',
    tag: 'Rústico',
    material: 'Madera Sólida',
    description: 'Litera/loft rústico minimalista con 4 postes gruesos de madera. Matrimonial abajo e individual arriba. Barandal de seguridad superior.',
    image: 'https://www.exportmuebles.com/assets/uploads/49f6111e-11c1-4a82-9e67-06d600d08619/46cebb34-3e09-4b17-af61-bbddd58108a4.jpg?w=480',
    dimensions: 'Matrimonial+Individual',
    price: null,
  },
  {
    id: 76,
    name: 'Buró X-Frame – Madera y Metal',
    category: 'Recámaras',
    tag: 'Mid-Century',
    material: 'Madera Sólida',
    description: 'Buró mid-century con base en cruz X de madera y metal, 2 cajones y jaladeras en acabado satinado. Limpio, funcional y con carácter.',
    image: 'https://www.exportmuebles.com/assets/uploads/49f6111e-11c1-4a82-9e67-06d600d08619/7ffee344-4968-4d45-a3f3-abe6a192c1bd.jpg?w=480',
    dimensions: '48×40×56 cm',
    price: null,
  },
  {
    id: 77,
    name: 'Buró Línea Nórdica – Minimalista',
    category: 'Recámaras',
    tag: 'Nórdico',
    material: 'Madera Sólida',
    description: 'Buró nórdico con nicho superior abierto, cajón con jaladera tipo barra y repisa baja para libros. Funcionalidad escandinava.',
    image: 'https://www.exportmuebles.com/assets/uploads/49f6111e-11c1-4a82-9e67-06d600d08619/32ecf66f-e3c2-474b-a5f9-d691969d69e0.jpg?w=480',
    dimensions: '50×35×65 cm',
    price: null,
  },

  // ── OFICINA ────────────────────────────────────────────────────────────────
  {
    id: 78,
    name: 'Mesa de Conferencia Ejecutiva',
    category: 'Oficina',
    tag: 'Ejecutivo',
    material: 'Madera Sólida',
    description: 'Mesa de conferencia para 10-12 personas en madera sólida con inserto central de granito negro y base en X. Presencia ejecutiva de primer nivel.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/b3f0c209-c300-4992-8e31-05c24c64d100/publicContain',
    dimensions: '300×120×75 cm',
    price: null,
  },
  {
    id: 79,
    name: 'Escritorio Direccional en L',
    category: 'Oficina',
    tag: 'Ejecutivo',
    material: 'Madera Sólida',
    description: 'Escritorio direccional en L con cubierta amplia y placa de piedra natural integrada. Incluye credenza lateral. Para directivos y despachos.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/c9b31e35-f7bf-43d8-5009-76cb865c7500/public',
    dimensions: '200×160×75 cm',
    price: null,
  },
  {
    id: 80,
    name: 'Escritorio Moderno Parota con Detalles Negros',
    category: 'Oficina',
    tag: 'Moderno',
    material: 'Parota',
    description: 'Escritorio de parota con franja central de madera natural y alas laterales en negro. 2 cajones con correderas soft-close. Diseño moderno premium.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/b1e66843-93be-425e-1588-595922339900/publicContain',
    dimensions: '160×75×75 cm',
    price: null,
  },
  {
    id: 81,
    name: 'Escritorio Ejecutivo de Madera',
    category: 'Oficina',
    tag: 'Clásico',
    material: 'Madera Sólida',
    description: 'Escritorio ejecutivo en madera sólida de tono cálido con vetas naturales marcadas. Base en T y cubierta de gran espesor. Para despacho u oficina.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/5c6c7aa9-ce90-4059-26fc-3badcc4cdd00/public',
    dimensions: '180×90×75 cm',
    price: null,
  },

  // ── EQUIPALES ──────────────────────────────────────────────────────────────
  {
    id: 82,
    name: 'Juego de Comedor Estilo Hacienda',
    category: 'Equipales',
    tag: 'Hacienda',
    material: 'Cuero',
    description: 'Conjunto comedor estilo hacienda con mesa rectangular, figura central sólida de madera y 8 sillas equipales tapizadas en piel curtida natural.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/6d89ebe4-0a87-4c95-5c56-b171b7926c00/publicContain',
    dimensions: 'Mesa 200×90 cm · 8 sillas',
    price: null,
  },
  {
    id: 83,
    name: 'Sala Equipal 3–2–1',
    category: 'Equipales',
    tag: 'Clásico',
    material: 'Cuero',
    description: 'Sala completa de equipal: sofá 3 plazas, sofá 2 plazas y sillón 1 plaza. Madera tallada y piel curada artesanalmente. Tradición mexicana.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/08eb416a-97b4-405e-6233-d11847fedc00/public',
    dimensions: 'Sofá 3px: 220×80 cm',
    price: null,
  },
  {
    id: 84,
    name: 'Juego Bistró Equipal',
    category: 'Equipales',
    tag: 'Bistró',
    material: 'Cuero',
    description: 'Juego bistró de 5 piezas: mesa redonda alta con 4 bancos altos con respaldo. Cuero natural color tabaco. Perfecto para bares y restaurantes.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/82561ead-a304-4cf5-9d1e-1912740a4400/publicContain',
    dimensions: 'Mesa 80 cm diámetro × 105 cm',
    price: null,
  },
  {
    id: 85,
    name: 'Juego Bistró Equipal Redondo',
    category: 'Equipales',
    tag: 'Bistró',
    material: 'Cuero',
    description: 'Juego bistró 5 piezas con mesa redonda y 4 sillas equipales con respaldo en cuero tabaco. Base cilíndrica. Estilo mexicano atemporal.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/49b7d4ee-d45f-46df-b4ae-8ac46dd87b00/publicContain',
    dimensions: 'Mesa 80 cm diámetro × 75 cm',
    price: null,
  },
  {
    id: 86,
    name: 'Juego Bistró Equipal Blanco',
    category: 'Equipales',
    tag: 'Bistró',
    material: 'Cuero',
    description: 'Juego bistró 5 piezas con mesa rectangular y 4 sillas equipales en tapicería blanca acolchada. Elegante versión clara del equipal clásico.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/6e8d5a9c-eb14-4108-02b3-c96480415400/publicContain',
    dimensions: 'Mesa 100×60 cm · 4 sillas',
    price: null,
  },

  // ── ACCESORIOS ─────────────────────────────────────────────────────────────
  {
    id: 87,
    name: 'Lámpara de Piso Torre Truss',
    category: 'Accesorios',
    tag: 'Iluminación',
    material: 'Parota',
    description: 'Lámpara de piso con estructura geométrica de parota tipo truss y tres focos Edison. Proyecta sombras decorativas espectaculares.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/caffdd18-ad99-4ea6-6115-467797e2c500/publicContain',
    dimensions: '35×35×165 cm',
    price: null,
  },
  {
    id: 88,
    name: 'Bar Modular en Parota con Iluminación LED',
    category: 'Accesorios',
    tag: 'Entretenimiento',
    material: 'Parota',
    description: 'Bar modular de parota con tiras LED cálidas embebidas, 2 módulos vitrina, porta-copas integrado y botellero para 12 botellas. El bar soñado.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/fdd0a592-0334-4c65-f02b-120425f42a00/public',
    dimensions: '120×45×180 cm',
    price: null,
  },
  {
    id: 89,
    name: 'Perchero Tótem',
    category: 'Accesorios',
    tag: 'Nórdico',
    material: 'Madera Sólida',
    description: 'Perchero de pie con 4 brazos en V y base tipo trípode con cruceta. Disponible en parota o teca. Funcional y escultórico.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/4928e339-3519-42aa-0d59-3fc75e7be400/publicContain',
    dimensions: '40×40×175 cm',
    price: null,
  },
  {
    id: 90,
    name: 'Alacena Quadra – 4 Puertas',
    category: 'Accesorios',
    tag: 'Artesanal',
    material: 'Parota',
    description: 'Alacena de parota con 4 puertas de cuarterones biselados con marcos a inglete y tiradores negros. Perfecta para cocina, comedor o sala.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/d188ef4f-e231-4369-dbac-df448c4ac500/public',
    dimensions: '140×42×180 cm',
    price: null,
  },
  {
    id: 91,
    name: 'Ruedas Hacienda (par decorativo)',
    category: 'Accesorios',
    tag: 'Decorativo',
    material: 'Madera Sólida',
    description: 'Par de ruedas de carreta artesanales en madera sólida con acabado envejecido. Montadas sobre bases estables para exhibición. Estilo hacienda.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/aa29dc9c-e124-415d-887b-617e7ee47a00/public',
    dimensions: '100 cm diámetro (c/u)',
    price: null,
  },
  {
    id: 92,
    name: 'Cama Elevada para Mascotas',
    category: 'Accesorios',
    tag: 'Mascotas',
    material: 'Parota',
    description: 'Cama elevada para mascotas grandes en parota maciza con colchón ortopédico incluido y patas elevadas para circulación de aire. Premium para tu mascota.',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/811a9415-4717-4249-2739-6c9f40692c00/public',
    dimensions: '90×65×35 cm',
    price: null,
  },
  {
    id: 93,
    name: 'Toallero de Piso – Marco Doble',
    category: 'Accesorios',
    tag: 'Japandi',
    material: 'Madera Sólida',
    description: 'Toallero de piso con dos niveles y base rectangular. Estilo minimalista japandi. Para baño o spa. Madera de acabado mate cálido.',
    image: 'https://www.exportmuebles.com/assets/uploads/49f6111e-11c1-4a82-9e67-06d600d08619/b422e4d3-000d-4f2f-94aa-be05e187125e.jpg?w=480',
    dimensions: '45×25×90 cm',
    price: null,
  },
];

export const projects = [
  {
    id: 1,
    name: 'Restaurante El Jardín',
    type: 'Restaurante',
    location: 'Guadalajara, Jalisco',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/57a3d564-5eae-4d46-bbdf-ac701763f900/public',
    description: 'Conjunto de 20 mesas y 80 sillas en parota para restaurante de jardín en Guadalajara.',
  },
  {
    id: 2,
    name: 'Residencia Sierra Madre',
    type: 'Hogar',
    location: 'Zapopan, Jalisco',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7875e675-e29f-47fe-69f2-cf263bf69c00/public',
    description: 'Comedor, recámara principal y sala en parota y rosa morada para residencia de lujo.',
  },
  {
    id: 3,
    name: 'Hotel Boutique Tonalá',
    type: 'Hotel',
    location: 'Tonalá, Jalisco',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f5741ec8-762a-4cb7-7939-61490a958300/public',
    description: 'Mobiliario completo para 12 habitaciones y áreas comunes en parota con acabado satinado.',
  },
  {
    id: 4,
    name: 'Taquería La Fondita',
    type: 'Restaurante',
    location: 'Ciudad de México',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/c2b3bf20-961f-48d8-e2e4-dd1dd2d0ec00/public',
    description: '30 mesas de mezquite y 120 sillas para cadena de taquerías en CDMX.',
  },
  {
    id: 5,
    name: 'Casa Lomas Chapultepec',
    type: 'Hogar',
    location: 'Ciudad de México',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/2fa55f9f-dee5-4c1f-18f4-cadc57e26600/publicContain',
    description: 'Comedor live edge de 10 personas y conjunto de sala para penthouse en Lomas de Chapultepec.',
  },
  {
    id: 6,
    name: 'Terraza Club de Playa',
    type: 'Exterior',
    location: 'Puerto Vallarta',
    image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/86f2bc25-726a-4a26-c863-36777bd71b00/public',
    description: '50 conjuntos de teca certificada para terraza frente al mar en club privado.',
  },
];

export const galleryImages = [
  // Comedores (4 images)
  { id: 1, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/c2b3bf20-961f-48d8-e2e4-dd1dd2d0ec00/public', alt: 'Conjunto comedor cuadrado 8 personas en parota', category: 'Comedores' },
  { id: 2, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/31da9c3d-34b7-4ec6-d370-71125f17e300/publicContain', alt: 'Comedor live edge parota 6 plazas', category: 'Comedores' },
  { id: 3, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/70d85220-10f5-42c0-bf9d-15199be56700/publicContain', alt: 'Mesa river table con vidrio templado', category: 'Comedores' },
  { id: 4, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/57a3d564-5eae-4d46-bbdf-ac701763f900/public', alt: 'Comedor redondo parota con sillas tejidas', category: 'Comedores' },
  // Sillas & Bancas (4 images)
  { id: 5, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/08bbce40-0101-4a0b-567b-39a2073b8b00/public', alt: 'Silla comedor respaldo tejido ratán parota', category: 'Sillas & Bancas' },
  { id: 6, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7ec9abe7-c6ad-45a1-95a4-4e5f45c36400/public', alt: 'Silla Cronos mid-century madera sólida', category: 'Sillas & Bancas' },
  { id: 7, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/d4532b22-3e0b-44ee-ae38-fca3cef39e00/public', alt: 'Banco tejido de ratán', category: 'Sillas & Bancas' },
  { id: 8, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7ab084c1-97d6-48ff-1e75-feb5d5d40b00/public', alt: 'Silla Wishbone escandinava', category: 'Sillas & Bancas' },
  // Sala (3 images)
  { id: 9, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/e755a61f-077d-416e-677b-78223d736000/public', alt: 'Sofá seccional parota Milano mid-century', category: 'Sala' },
  { id: 10, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/0e57af0c-ae7b-4162-b129-3ff0ab54fe00/public', alt: 'Sofá Chester parota navy azul', category: 'Sala' },
  { id: 11, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/2e8f7656-e91d-4274-25a6-fdd1bf2e8b00/public', alt: 'Mesa de centro orgánica parota', category: 'Sala' },
  // Recámaras (3 images)
  { id: 12, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7875e675-e29f-47fe-69f2-cf263bf69c00/public', alt: 'Recámara moderna completa en parota', category: 'Recámaras' },
  { id: 13, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/03279303-3fd8-459f-a596-59c7c5b32c00/public', alt: 'Cama plataforma rosa morada', category: 'Recámaras' },
  { id: 14, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/c7ae704a-59a2-4908-5233-37c6c7f33500/public', alt: 'Cama parota cabecera curva modular', category: 'Recámaras' },
  // Exterior (2 images)
  { id: 15, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f5741ec8-762a-4cb7-7939-61490a958300/public', alt: 'Conjunto terraza cuerda náutica parota', category: 'Exterior' },
  { id: 16, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7c5c8fdd-34b0-4477-3242-556071c10a00/publicContain', alt: 'Camastro de teca para exterior', category: 'Exterior' },
  // Consolas & TV (2 images)
  { id: 17, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a67b1d12-a852-4ee7-071f-9529145ef700/public', alt: 'Consola moderna lacada negro mate', category: 'Consolas & TV' },
  { id: 18, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/eab1f32e-4638-4b28-2947-3de95e823100/publicContain', alt: 'Consola rosa morada estilo caballete', category: 'Consolas & TV' },
  // Oficina (2 images)
  { id: 19, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/b3f0c209-c300-4992-8e31-05c24c64d100/publicContain', alt: 'Mesa de conferencia ejecutiva madera sólida', category: 'Oficina' },
  { id: 20, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/c9b31e35-f7bf-43d8-5009-76cb865c7500/public', alt: 'Escritorio direccional en L ejecutivo', category: 'Oficina' },
  // Equipales (2 images)
  { id: 21, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/6d89ebe4-0a87-4c95-5c56-b171b7926c00/publicContain', alt: 'Juego comedor estilo hacienda con equipales', category: 'Equipales' },
  { id: 22, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/08eb416a-97b4-405e-6233-d11847fedc00/public', alt: 'Sala equipal 3-2-1 cuero natural', category: 'Equipales' },
  // Accesorios (2 images)
  { id: 23, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/fdd0a592-0334-4c65-f02b-120425f42a00/public', alt: 'Bar modular parota con iluminación LED', category: 'Accesorios' },
  { id: 24, src: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/d188ef4f-e231-4369-dbac-df448c4ac500/public', alt: 'Alacena Quadra 4 puertas en parota', category: 'Accesorios' },
];

export const restaurantBenefits = [
  {
    title: 'Diseño Funcional',
    description: 'Mobiliario pensado para la operación diaria de restaurantes, bares y cafeterías. Ergonomía y estética en equilibrio.',
    icon: '📐',
  },
  {
    title: 'Durabilidad Comercial',
    description: 'Maderas y acabados seleccionados para resistir el uso intensivo diario. Inversión que dura décadas.',
    icon: '🛡️',
  },
  {
    title: 'Producción en Volumen',
    description: 'Capacidad para fabricar grandes cantidades manteniendo la calidad artesanal en cada pieza.',
    icon: '🏭',
  },
  {
    title: 'Personalización Total',
    description: 'Cada pieza se adapta a tu concepto, paleta de colores, medidas y tipo de madera.',
    icon: '🎨',
  },
  {
    title: 'Envío a Todo México y EE.UU.',
    description: 'Coordinamos flete especializado puerta a puerta con embalaje protegido para proyectos comerciales.',
    icon: '🚚',
  },
  {
    title: 'Asesoría de Diseño',
    description: 'Desde el concepto hasta la instalación. Te acompañamos en cada etapa de tu proyecto.',
    icon: '💡',
  },
];

export const processSteps = [
  { step: 1, title: 'Cotización Gratuita', description: 'Comparte tus medidas e ideas por WhatsApp. Respondemos en menos de 24 horas con opciones y precios.' },
  { step: 2, title: 'Diseño y Aprobación', description: 'Creamos renders y planos técnicos para que veas exactamente cómo quedará tu mueble.' },
  { step: 3, title: 'Fabricación Artesanal', description: 'Nuestros maestros artesanos construyen tu mueble en 2 semanas con maderas certificadas.' },
  { step: 4, title: 'Entrega en Tu Puerta', description: 'Embalaje especializado y envío coordinado a cualquier parte de México y Estados Unidos.' },
];

export const stats = [
  { number: '20+', label: 'Años de Experiencia' },
  { number: '5,000+', label: 'Piezas Entregadas' },
  { number: '800+', label: 'Clientes Satisfechos' },
  { number: '2 sem.', label: 'Tiempo de Entrega' },
];

export const faqs = [
  { q: '¿Cuánto tiempo tarda la fabricación?', a: 'Nuestro tiempo estándar es 2 semanas desde la aprobación del diseño. Proyectos más complejos pueden tomar hasta 4 semanas. Mucho más rápido que talleres tradicionales.' },
  { q: '¿Qué tipos de madera trabajan?', a: 'Trabajamos con maderas premium mexicanas certificadas: Parota (durable, vetas cálidas), Rosa Morada (tono rojizo exclusivo), Tzalam (resistente, vetas onduladas) y Mezquite (extremadamente dura). También teca para exterior.' },
  { q: '¿Hacen envíos fuera de Tonalá?', a: 'Sí, enviamos a toda la República Mexicana y a Estados Unidos con embalaje especializado. Coordinamos flete puerta a puerta.' },
  { q: '¿Puedo personalizar el diseño, medidas y acabados?', a: 'Absolutamente. Todos nuestros muebles son a la medida. Adaptamos dimensiones, tipo de madera, acabado (natural, mate, satinado, pintado) y tapizado según tu espacio y estilo.' },
  { q: '¿Cuánto cuesta un mueble a medida?', a: 'El precio depende de la madera, tamaño y complejidad. Al ser fabricantes directos, nuestros precios son competitivos sin intermediarios. Contáctanos por WhatsApp para una cotización gratuita.' },
  { q: '¿Trabajan proyectos comerciales (restaurantes, hoteles)?', a: 'Sí, tenemos amplia experiencia en proyectos de volumen para restaurantes, bares, cafeterías y hoteles. Desde una silla hasta todo el mobiliario de tu negocio.' },
  { q: '¿Ofrecen garantía?', a: 'Todos nuestros muebles tienen garantía de calidad. Usamos maderas certificadas y acabados premium. Respaldamos la durabilidad de cada pieza que fabricamos.' },
  { q: '¿Dónde están ubicados?', a: 'Estamos en And. Tonaltecas 200-L 21, Tonalá Centro, 45400 Tonalá, Jalisco — el corazón artesanal de México. Puedes visitarnos o cotizar por WhatsApp sin necesidad de venir.' },
];

export const woodTypes = [
  { name: 'Parota', swatch: '#8B5E3C', origin: 'Jalisco · Colima', description: 'Madera de veta espectacular con nudos naturales. Ideal para mesas de comedor y piezas centrales. Alta resistencia y acabado natural incomparable.' },
  { name: 'Rosa Morada', swatch: '#7B4F6A', origin: 'Michoacán · Guerrero', description: 'Una de las maderas más duras de México. Tonos violáceos únicos que se intensifican con el tiempo. Perfecta para detalles de alta gama.' },
  { name: 'Tzalam', swatch: '#6B4226', origin: 'Yucatán · Campeche', description: 'Madera tropical de la selva maya. Excepcional estabilidad dimensional. Resistente a la humedad, ideal para piezas de exterior premium.' },
  { name: 'Mezquite', swatch: '#A0522D', origin: 'Jalisco · Guanajuato', description: 'Madera del norte de México con veta dramática y colores cálidos. Su dureza la hace perfecta para barras, mesas y superficies de trabajo.' },
  { name: 'Teca', swatch: '#C4A05A', origin: 'Importación certificada', description: 'La reina de las maderas para exterior. Aceites naturales que resisten la intemperie. Certificación FSC. Mantenimiento mínimo por décadas.' },
];
